import { Either } from "fp-ts/lib/Either";
import ErrorEntity from "../entities/ErrorEntity";
import UserEntity from "../entities/UserEntity";

export default interface AuthRepository {
    loginWithEmailAndPassword(email: string, password: string): Promise<Either<ErrorEntity, UserEntity>>;
    getCurrentUser(): Promise<UserEntity | null>;
    logout(): Promise<Either<ErrorEntity, void>>;
}

export const AuthRepositoryName = "AuthRepository";